import { useNavigate } from "react-router-dom";

export default function TermsOfService() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white font-outfit text-slate-700">
      <header className="border-b border-slate-100 px-6 py-4 flex items-center justify-between">
        <button onClick={() => navigate("/")} className="font-manrope text-xl font-bold">
          <span className="text-slate-800 dark:text-slate-100">Host</span><span className="text-amber-500">Folio</span>
        </button>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="font-manrope text-3xl font-bold text-slate-900 dark:text-amber-400 mb-2">Terms of Service</h1>
        <p className="text-sm text-slate-400 mb-10">Last updated: {new Date().toLocaleDateString("en-IN", { year:"numeric", month:"long", day:"numeric" })}</p>

        <section className="space-y-8 text-sm leading-relaxed text-slate-600">
          <div>
            <h2 className="text-lg font-bold text-slate-800 mb-2">1. Acceptance of Terms</h2>
            <p>By accessing or using HostFolio ("Service"), you agree to be bound by these Terms of Service. If you do not agree, please do not use the Service.</p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-slate-800 mb-2">2. Description of Service</h2>
            <p>HostFolio is a SaaS property management platform for short-term rental hosts and property managers. Features include calendar sync, booking management, expense tracking, AI-powered pricing, guest messaging and task management.</p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-slate-800 mb-2">3. Account Registration</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>You must provide accurate information when creating an account.</li>
              <li>You are responsible for maintaining the security of your account credentials.</li>
              <li>You must be at least 18 years old to use the Service.</li>
              <li>One person may not maintain more than one free account.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-slate-800 mb-2">4. Subscription and Payments</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Paid plans are billed monthly. Prices are in Indian Rupees (INR) and include applicable taxes.</li>
              <li>Payments are processed by Razorpay. By subscribing, you authorise Razorpay to charge your payment method.</li>
              <li>Subscriptions renew automatically unless cancelled before the renewal date.</li>
              <li>No refunds are provided for partial months.</li>
              <li>We reserve the right to change pricing with 30 days notice.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-slate-800 mb-2">5. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>Use the Service for any unlawful purpose.</li>
              <li>Attempt to gain unauthorised access to any part of the Service.</li>
              <li>Reverse engineer, decompile or disassemble the Service.</li>
              <li>Resell or sublicense the Service without written permission.</li>
              <li>Upload malicious code or interfere with the Service's operation.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-slate-800 mb-2">6. AI Features</h2>
            <p>AI-powered features (pricing suggestions, smart replies, property evaluation) are provided as suggestions only. HostFolio does not guarantee the accuracy of AI outputs. You are solely responsible for any decisions made based on AI suggestions.</p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-slate-800 mb-2">7. Data and Privacy</h2>
            <p>Your use of the Service is also governed by our <a href="/privacy" className="text-amber-500">Privacy Policy</a>. You retain ownership of all data you input into the Service. By using the Service, you grant us a limited licence to process your data solely to provide the Service. You also grant us a licence to use <strong>aggregated, anonymized</strong> data derived from your bookings (such as nightly rates, occupancy, and property attributes) to develop and improve our pricing, demand-prediction, and analytics models for the benefit of all hosts. This aggregated data does not identify you, your guests, or your individual bookings, and contains no personally identifiable guest information.</p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-slate-800 mb-2">8. Availability and Uptime</h2>
            <p>We strive for high availability but do not guarantee uninterrupted access. We are not liable for losses resulting from downtime, maintenance or technical failures.</p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-slate-800 mb-2">9. Limitation of Liability</h2>
            <p>To the maximum extent permitted by law, HostFolio shall not be liable for any indirect, incidental, special, consequential or punitive damages, including loss of revenue or data, arising from your use of the Service. Our total liability shall not exceed the amount paid by you in the 12 months preceding the claim.</p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-slate-800 mb-2">10. Termination</h2>
            <p>You may cancel your account at any time from the Settings page. We reserve the right to suspend or terminate accounts that violate these Terms. Upon termination, your data will be retained for 30 days before permanent deletion.</p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-slate-800 mb-2">11. Governing Law</h2>
            <p>These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts of Bengaluru, Karnataka, India.</p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-slate-800 mb-2">12. Contact</h2>
            <p>For any questions about these Terms, email <a href="mailto:support@hostfolio.in" className="text-amber-500">support@hostfolio.in</a>.</p>
          </div>
        </section>
      </main>
      <footer className="border-t border-slate-100 py-6 text-center text-xs text-slate-400">
        © {new Date().getFullYear()} HostFolio · <a href="/privacy" className="hover:text-slate-600">Privacy Policy</a>
      </footer>
    </div>
  );
}
